import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    auth: null,
    error: false,
    errorMessage: "",
  },
  reducers: {
    getActiveUserDetails: (state, action) => {
      state.active_user = action.payload;
    },
    adminInviteStart: (state) => {
      state.user_invite = null;
      state.error = false;
      state.errorMessage = "";
    },
    adminInviteSuccess: (state, action) => {
      state.user_invite = action.payload;
      state.error = false;
      state.errorMessage = "";
    },
    adminInviteFailure: (state, error) => {
      state.user_invite = null;
      state.error = true;
      state.errorMessage = error.payload;
    },
    adminInviteDetailsStart: (state) => {
      state.user_invite_details = null;
      state.error = false;
      state.errorMessage = "";
    },
    adminInviteDetailsSuccess: (state, action) => {
      state.user_invite_details = action.payload;
      state.error = false;
      state.errorMessage = "";
    },
    adminInviteDetailsFailure: (state, error) => {
      state.user_invite_details = null;
      state.error = true;
      state.errorMessage = error.payload;
    },
    verifyUserEventStart: (state) => {
      state.user_verified = null;
      state.error = false;
      state.errorMessage = "";
    },
    verifyUserEventSuccess: (state, action) => {
      state.user_verified = action.payload;
      state.error = false;
      state.errorMessage = "";
    },
    verifyUserEventFailure: (state, error) => {
      state.user_verified = null;
      state.error = true;
      state.errorMessage = error.payload;
    },
  },
});

export const {
  getActiveUserEventStart,
  getActiveUserDetails,
  getActiveUserEventFailure,
  adminInviteStart,
  adminInviteSuccess,
  adminInviteFailure,
  adminInviteDetailsStart,
  adminInviteDetailsSuccess,
  adminInviteDetailsFailure,
  verifyUserEventStart,
  verifyUserEventSuccess,
  verifyUserEventFailure,
} = authSlice.actions;
export default authSlice.reducer;
